import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieBanner.css';
import {
  getCookieConsentValue,
  setCookieConsent,
} from './cookieConsent';

const CookieBanner = ({ onConsentChange }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const bannerRef = useRef(null);
  const position = useRef({ x: 0, y: 0 });
  const offset = useRef({ x: 0, y: 0 });
  const dragging = useRef(false);

  useEffect(() => {
    const consent = getCookieConsentValue();
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent(true);
    onConsentChange?.(true);
    setIsVisible(false);
  };

  const handleDeny = () => {
    setCookieConsent(false);
    onConsentChange?.(false);
    setIsVisible(false);
  };

  const handleMouseDown = (e) => {
    if (!bannerRef.current) return;
    const rect = bannerRef.current.getBoundingClientRect();
    position.current = { x: rect.left, y: rect.top };
    bannerRef.current.style.left = `${rect.left}px`;
    bannerRef.current.style.top = `${rect.top}px`;
    bannerRef.current.style.bottom = 'auto';
    bannerRef.current.style.right = 'auto';
    dragging.current = true;
    offset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const handleMouseMove = (e) => {
    if (!dragging.current || !bannerRef.current) return;
    const newX = e.clientX - offset.current.x;
    const newY = e.clientY - offset.current.y;
    bannerRef.current.style.left = `${newX}px`;
    bannerRef.current.style.top = `${newY}px`;
  };

  const handleMouseUp = () => {
    dragging.current = false;
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      ref={bannerRef}
      onMouseDown={handleMouseDown}
      className="cookie-card"
    >
      <span className="title">🍪 {t('cookieTitle')}</span>
      <p className="description">
        {t('cookieDescription')}{' '}
        <Link to="/cookie-policy">{t('cookiePolicyLink')}</Link>
      </p>
      <div className="actions">
        <button className="pref" onClick={handleDeny}>
          {t('cookieDeny') || 'Reject'}
        </button>
        <button className="accept" onClick={handleAccept}>
          {t('cookieAccept')}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
